﻿function initSessionStorage(itemKey, initValue){
  itemKey = itemKey || ''
  initValue = typeof initValue == 'undefined' ? '' : initValue
  let _checkBrowserSupportSessionStorage = () => 'sessionStorage' in window
  if(!_checkBrowserSupportSessionStorage()){
    throw new Error('not support sessionStorage in this browser')
  }
  let _initItemSessionStorage = () => {
    if(!sessionStorage.getItem(itemKey)) {
      let type = typeof initValue
      switch (type) {
        case 'object':
          sessionStorage.setItem(itemKey, JSON.stringify(initValue))
          break
        case 'number':
        case 'string':
          sessionStorage.setItem(itemKey, initValue)
          break  
        default:
          throw new Error(`type [${type}] init sessionStorage not supported`)
      }
    }
  }
  let _resetValueItemSessionStorage = () => { 
    let item = _getValueItemSessionStorage()
    if(typeof item == 'object'){
      sessionStorage.setItem(itemKey, [])
    } else sessionStorage.setItem(itemKey, '')
  }
  let _getValueItemSessionStorage = () => {
    _initItemSessionStorage()
    return typeof initValue == 'object' ? JSON.parse(sessionStorage.getItem(itemKey)) : sessionStorage.getItem(itemKey)
  }
  let _setValueItemSessionStorage = (value) => {
    let item = _getValueItemSessionStorage()
    if(typeof item == 'object'){
      item.push(value)
      sessionStorage.setItem(itemKey, JSON.stringify(item))
    } else sessionStorage.setItem(itemKey, value)
  }
  let _lastItemSessionStorage = () => {
    let item = _getValueItemSessionStorage()
    return typeof item == 'object' && item.length ? JSON.parse(item[item.length - 1]) : null
  }
  let _updateOptionClickedSessionStorage = (value) => {
    let item = _getValueItemSessionStorage()
    if(typeof item == 'object'){
      let foundIndex = item.findIndex((x => x.id == value.id_option))      
      if(foundIndex !== -1 ) {
      if(item[foundIndex].type === 'option'){
        let optionIndexClicked = item[foundIndex].payload.options.findIndex((x => x.label === value.labelButton))
        item[foundIndex].payload.options[optionIndexClicked].clicked = 'reply-clicked'
        sessionStorage.setItem(itemKey, JSON.stringify(item))
      } else sessionStorage.setItem(itemKey, value)
    }
  }
  }
  let _deleteLastItemTypeSessionStorage = (value) => {
    let item = _getValueItemSessionStorage()
    if(typeof item == 'object'){
      let foundIndex = item.findIndex((x => x.type == value))
      if (foundIndex && foundIndex > -1) {
        item.splice(foundIndex, 1)    
        sessionStorage.setItem(itemKey, JSON.stringify(item))
      }      
    }
  }
  return {
    set     : _setValueItemSessionStorage,
    get     : _getValueItemSessionStorage,
    reset   : _resetValueItemSessionStorage,
    getLast : _lastItemSessionStorage,
    updateOption  : _updateOptionClickedSessionStorage,
    deleteLastItemType  : _deleteLastItemTypeSessionStorage
  }
}
initSessionStorage()
export default initSessionStorage
